import { render } from "./OurAchievements.vue?vue&type=template&id=28756e44&scoped=true"
import script from "./OurAchievements.vue?vue&type=script&lang=js"
export * from "./OurAchievements.vue?vue&type=script&lang=js"

import "./OurAchievements.vue?vue&type=style&index=0&id=28756e44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28756e44"]])

export default __exports__